'use client';

import { MappingSpinner, mappingSpinnerTag } from '@ni/nimble-components/dist/esm/mapping/spinner';
import { wrap } from '../../utilities/react-wrapper';

export { mappingSpinnerTag };
export { type MappingSpinner };
export const NimbleMappingSpinner = wrap(MappingSpinner);
